
export const VAT_PERCENTAGE_IN_SAUDI = 15
export const INITIAL_PAYMENT = 300
export const FULLTIME_PARTNER_ID_KEY = 'fulltime-partner-id'
export const FULLTIME_PARTNER_TOKEN_KEY = 'fulltime-partner-token'
export const APP_VERSION_KEY = 'app-version'
export const LOOKUPS_VERSION_KEY = 'lookups-version'
export const WORKER_ID_KEY = 'worker-id'
export const WORKER_TOKEN_KEY = 'worker-token'
export const IS_SABBAR_APPROVED = 'is-sabbar-approved'
export const PARTNER_STATUS = 'partner-status';
export const PARTNER_STATUS_MODAL_SHOWN = 'partner-status-modal-shown';
export const AGGREGATED_PARTNER_KEY = 'aggregated-partner';
export const APPLICANTS_PAGE_LIMIT = 10;
export const VETTING_APPLICANTS_PAGE_LIMIT = 7;
export const MASS_HIRING_APPLICANTS_PAGE_LIMIT = 50;
export const MASS_HIRING_APPLICANTS__KANBAN_PAGE_LIMIT = 15;
export const ENTERPRISE_USERS_PAGE_LIMIT = 50;
export const ENTERPRISE_LOCATIONS_PAGE_LIMIT = 100;
export const JOB_TEMPLATES_PAGE_LIMIT = 50;
export const ENTERPRISE_JOB_POSTS_PAGE_LIMIT = 20;
export const PLG_JOB_POSTS_PAGE_LIMIT = 20;
export const WHATSAPP_TEMPLATES_PAGE_LIMIT = 100;
export const WHATSAPP_INBOX_DEFAULT_LIMIT = 20;
export const INTERVIEW_INVITATIONS_PAGE_SIZE = 50;
export const ONBOARDING_PAGE_SIZE = 10;
/** When false, onboarding uses mock API with 400ms delay. Set true when backend is ready. */
export const isOnboardingBackendReady = false;
export const CACHED_APPLICANTS_KEY = 'cached-applicants';
export const CACHED_API_REQUESTS_KEY = 'cached-api-requests';
export const API_REQUESTS_CACHE_INTERVAL_IN_SECONDS = 180; // 3 minutes
export const APPLICANTS_CACHE_INTERVAL = 180; // 3 minutes
export const CHATS_PAGE_LIMIT = 6;
export const CV_SEARCH_PAGE_LIMIT = 5;
export const CV_SEARCH_INPUTS_LS_KEY = 'cv-search-inputs';
export const JOB_DESCRIPTION_MAX_LIMIT_WITHOUT_HTML = 5000;
/** When true, validate-job-post OFFENSIVE / SPAM / FRAUD responses redirect to /jobs and refresh partner profile. */
export const NAVIGATE_ON_FRAUD_JOB = true;
export const MAX_FILTER_LIST_COUNT = 5;
export const SAUDI_COUNTRY_ONLY_ID = 'SA';
export const MH_VIEW_SELECTED_LS_KEY = 'mh-view-selected';
export const WHATSAPP_CONFIGURATION_ID = process.env.REACT_APP_WHATSAPP_CONFIGURATION_ID; // stg: 722550553954569, prod: 731751156209640
export const WHATSAPP_APP_ID = process.env.REACT_APP_WHATSAPP_APP_ID; // stg: 1889053951807103, prod: 567082839347602
export const WHATSAPP_SOLUTION_ID = '1369791294449221'; // Currently using can id in stg/prod, later might change it

export const COOKIE_UTMDATA = "_utmtrackdata";
export const COOKIE_FIRST_UTM = "utm_first_visit";
export const COOKIE_LAST_UTM = "utm_last_visit";
export const COOKIE_SAME_UTM = "utm_first_sameas_utm_last";
export const APPLE_PAY_PAYMENT_ID_KEY = "apple-pay-payment-id";

export const AppStoreLinkAr = "https://apps.apple.com/us/app/%D8%B5%D8%A8-%D8%A7%D8%B1-%D8%A7%D9%84%D9%85%D9%86%D8%B5%D8%A9-%D8%A7%D9%84%D8%B1%D8%A7%D8%A6%D8%AF%D8%A9-%D9%84%D9%84%D8%AA%D9%88%D8%B8%D9%8A%D9%81/id1449471472?l=ar"
export const AppStoreLinkEn = "https://apps.apple.com/us/app/sabbar-leading-recruitment-app/id1449471472?ppid=0facea8b-cb9a-4c57-b394-88c3dd716ada";
export const PlayStoreLinkAr = "https://play.google.com/store/apps/details?id=com.sabbar.seeker&listing=partner&hl=ar&gl=SA&pli=1";
export const PlayStoreLinkEn = "https://play.google.com/store/apps/details?id=com.sabbar.seeker&listing=partner&hl=en&gl=SA&pli=1";
export const DownloadAPPLinkEn = "https://sabbar.com/en/download-our-app"
export const DownloadAPPLinkAr = "https://sabbar.com/ar/download-our-app"
export const SABBAR_PROFILE_PDF_URL = "https://sabbar-prod-uploaded-files.s3.eu-west-1.amazonaws.com/static-files/email/Sabbar_SME.pdf"

//https://qjerf5r25qo.typeform.com/to/okHBKQey
export const JobPostTypoFormUrl = () => {
  return `https://qjerf5r25qo.typeform.com/to/IS8F8vwT#new_partner_id=${localStorage.getItem(FULLTIME_PARTNER_ID_KEY)}`;
}

export const WhatsAppContactMessage = (applicantName, jobTitle, partnerName) => {
  return `\u0627\u0644\u0633\u0644\u0627\u0645%20\u0639\u0644\u064A\u0643\u0645%20${applicantName}%0A\u0623\u062A\u0648\u0627\u0635\u0644%20\u0645\u0639\u0643%20\u0628\u062E\u0635\u0648\u0635%20\u062A\u0642\u062F\u064A\u0645\u0643%20\u0639\u0646%20\u0637\u0631\u064A\u0642%20\u0645\u0646\u0635\u0629%20\u0635\u0628\u0651\u0627\u0631%20\u0644\u0648\u0638\u064A\u0641\u0629%20${jobTitle}%20\u0641\u064A%20\u0634\u0631\u0643\u0629%20${partnerName}`
}

export const urlRegex = new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$');
export const MHRSD_GUIDELINES_URL = "https://www.hrsd.gov.sa/knowledge-centre/decisions-and-regulations/regulation-and-procedures/%D8%B6%D9%88%D8%A7%D8%A8%D8%B7-%D8%A7%D9%84%D8%A5%D8%B9%D9%84%D8%A7%D8%A1-%D8%B9%D9%86-%D8%A7%D9%84%D8%B4%D9%88%D8%A7%D8%BA%D8%B1-%D8%A7%D9%84%D9%88%D8%B8%D9%8A%D9%81%D9%8A%D8%A9-%D9%88%D8%A5%D8%AC%D8%B1%D8%A7%D8%A1-%D8%A7%D9%84%D9%85%D9%82%D8%A7%D8%A8%D9%84%D8%A7%D8%AA"
export const MobileNumberPattern = { SA: '^9665[0-9]{8}$' }
export const mobileRegex = '^5[0-9]{8}$'
export const GA_MEASUREMENT_ID = "G-7CSR8WT4C8"
export const GOOGLE_MAP_API_KEY = "AIzaSyA37FnLtf9Sp1Sliu8RoLl99VrouNsRq4Y";
export const WHATSAPP_NUMBER = "966920011375";
export const JOB_DETAILS_PATH = 'applicants';
export const APP_URL = process.env.REACT_APP_URL
export const GLITCH_TIP_DSN = "https://3070fdf0c18842bd903f615ee3aab75a@app.glitchtip.com/3536";
export const HOTJAR_SITE_ID = 3599538;
export const HOTJAR_VERSION = 6;
export const KSA_COUNTRY_CODE = 966;
export const emailRegex = /^\s*([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\s*$/;
export const vatRegex = /^3\d{13}3$/; // 15 digits, first and last numbers should be 3
export const APPLICANT_FILTER_KEY = 'applicant-filter-v2';
export const APPLE_PAY_VERSION = 5;
export const AGORA_APP_ID = 'af9aaf16de0b46ebab56105a8156abf3';
export const SABBAR_VIDEO_URL = 'https://sabbar-prod-uploaded-files.s3.amazonaws.com/static-files/sabbar_intro.mp4';
export const SAUD_AI_VIDEO = 'https://sabbar-prod-uploaded-files.s3.eu-west-1.amazonaws.com/static-files/saud-ai-video.mp4';
export const SAUD_AI_VIDEO_2 = 'https://youtube.com/shorts/_D6TEBDPfZc';
export const SAUD_DEMO_VIDEO = 'https://sabbar-prod-uploaded-files.s3.eu-west-1.amazonaws.com/static-files/saud-demo.mp4';
export const LOOKUPS_DATA_LS_KEY = 'paLookups';
export const USER_LOCATION_COORDS = 'userLocationCoords';
export const API_TIMEOUT = 80000;
export const RIYAL_URL = 'https://sabbar-prod-uploaded-files.s3.eu-west-1.amazonaws.com/static-files/riyal-icon-black.png';
export const TYPESENSE_HOST = 'asy3c2h8wj4q7fbzp.a1.typesense.net';
export const TYPESENSE_HOST_1 = 'asy3c2h8wj4q7fbzp-1.a1.typesense.net';
export const TYPESENSE_HOST_2 = 'asy3c2h8wj4q7fbzp-2.a1.typesense.net';
export const TYPESENSE_HOST_3 = 'asy3c2h8wj4q7fbzp-3.a1.typesense.net';
/** Typesense nodes for multi_search (round-robin first pick, then failover in list order) */
export const TYPESENSE_HOSTS = [TYPESENSE_HOST_1, TYPESENSE_HOST_2, TYPESENSE_HOST_3] as const;
export const TYPESENSE_APIKEY = 'bNWnhtVJk32em5Nrde9JA0vXp0lWkZ3n';

export const TYPESENSE_CONFIG = {
  headers: {
    'Content-Type': 'text/plain'
  },
  timeout: API_TIMEOUT
}
export const MAX_WORKER_SALARY = 10000;
export const PARTNERS_ALLOWED_UNLOCKS_TRIAL = ['0daef538-b81c-4c6c-9c2b-2bd543c47d35'];
export const DEFAULT_DISCOUNT_PERCENTAGE = 20;

export const APP_VERSION_NUMBER = "423";
export const LOOKUPS_VERSION_NUMBER = "21";
export const DISCOUNT_PERCENTAGE_PER_EXTRA_JOB = 5;
export const CAMPAIGN_DISCOUNT_PERCENTAGE = 25;

/** When false, hide AI CV Search / Combo tabs and related FAQ copy on pricing-v2. */
export const isAICVSearchEnabled = false;

export const SABBAR_PARTNER_DISCOUNT_MODAL_COOKIE = "sabbar-partner-discount-modal-seen";
export const SABBAR_ND_JOBS_POPUP_COOKIE = "sabbar-nd-jobs-popup-dismissed";